export default __webpack_public_path__ + "static/media/typecar.4d6ad9a8.svg";